
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const voucherTypeKarmaMasterService = createApi({
  reducerPath: "voucherTypeKarmaMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["voucherTypeKarmaMaster"],
  endpoints: (builder) => ({
    getAllVoucherTypeKarmaMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.getAllPaginated}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    searchVoucherTypeKarmaMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.search}`,
        method: "POST",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    saveVoucherTypeKarmaMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.save}`,
        method: "POST",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    updateVoucherTypeKarmaMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.update}/${body.id}`,
        method: "PUT",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    deleteVoucherTypeKarmaMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.delete}/${body.id}`,
        method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    getVoucherTypeKarmaMasterById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.getById}/${body.id}`,
        method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    getAllVoucherTypeKarmaMasterList: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.getAll}`,
        method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    uploadBulkVoucherTypeKarmaMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypekarmaMasterController.uploadBulk}`,
        method: "POST",
        body: body.payload,
          headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
  }),
});

export const {
  useGetAllVoucherTypeKarmaMasterMutation,
  useSearchVoucherTypeKarmaMasterMutation,
  useSaveVoucherTypeKarmaMasterMutation,
  useUpdateVoucherTypeKarmaMasterMutation,
  useDeleteVoucherTypeKarmaMasterMutation,
  useGetVoucherTypeKarmaMasterByIdMutation,
  useGetAllVoucherTypeKarmaMasterListMutation,
  useUploadBulkVoucherTypeKarmaMasterMutation,
} = voucherTypeKarmaMasterService;
